import { classNamePrefix as prefixCt } from "@/utils/common";
import { colorsMore, FONT_COLOR_DARK, FONT_COLOR_LIGHT } from "../consts";
import "../index.less";

const computeFontColor = (color: string) => {
  const index = colorsMore.findIndex((c: string) => c === color);

  if (index === -1) {
    return FONT_COLOR_DARK;
  }

  if (index % 12 < 1) {
    return FONT_COLOR_DARK;
  }

  if (index % 12 < 2) {
    return FONT_COLOR_LIGHT;
  }

  if (index > 11 && index < 36) {
    return FONT_COLOR_DARK;
  }

  return FONT_COLOR_LIGHT;
};

const computeStyle = (color: string, pattern: string) => {
  return `
    background: ${pattern === "fill" ? color : "#fff"};
    border-color: ${color};
    color: ${pattern === "fill" ? computeFontColor(color) : ""};
  `;
};

export default class statusRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("status")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    const { color = "#ccc", pattern = "fill" } = node.dataset;
    node.setAttribute("style", computeStyle(color, pattern));
  };
}
